import React, { useEffect, useState } from "react";
import "./animatedText.css";

const texts = [
  "Product Uses",
  "Document Authenticated",
  "Email Validated",
  "Tampering Checked",
  "Digital Signature Verified",
];

function AnimatedText() {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % texts.length);
    }, 2000); // change text every 2 seconds
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="animated-text-container mobile-hide">
      <div key={index} className="animated-text fade">
        {texts[index]}
      </div>
    </div>
  );
}

export default AnimatedText;
